import { isNullOrUndefined } from './collection';

/**
 * Given a "click" event, it will return true if the event is coming from a keyboard interaction, false otherwise
 * @param {Event} evt The event
 * @returns {boolean} True if keyboard, false if mouse
 */
export const isKeyboardClickEvent = (evt: Event): boolean =>
  evt instanceof KeyboardEvent ||
  (evt instanceof MouseEvent &&
    (evt.detail === 0 || isNullOrUndefined(evt.detail)) &&
    (evt.clientX === 0 || isNullOrUndefined(evt.clientX)) &&
    (evt.clientY === 0 || isNullOrUndefined(evt.clientY)));
